module.exports = "img/evento-alimentación.9ede90.png";